import { Button } from "@/components/catalyst/button";
import { useDialog } from "@/lib/Components/Dialog/Hooks/useDialog";
import { useRelocationRecord } from "@/app/Relocations/Hooks/useRelocationRecord";
import { AddDestinationsDialog } from "@/app/Relocations/Components/AddDestinationsDialog";
import { GitBranchPlusIcon } from "lucide-react";
import { RelocationAdditionalDestinationsTable } from "@/app/Relocations/Components/Tables/RelocationAdditionalDestinationsTable";

export function RelocationLinesScreen() {
  const record = useRelocationRecord();
  const { open } = useDialog(AddDestinationsDialog);

  return (
    <div className="py-6">
      <RelocationAdditionalDestinationsTable
        title="Additional destinations"
        id="relocation-additional-destinations"
        relocationId={record.id}
        rightButtons={
          <>
            <Button
              LeadingIcon={GitBranchPlusIcon}
              onClick={() => {
                open({
                  relocationId: record.id,
                });
              }}
            >
              Add destinations
            </Button>
          </>
        }
      />
    </div>
  );
}
